import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { MobileScaleService } from './services/mobile-scale.service';

const mobileOnly: CanActivateFn = () =>
    inject(MobileScaleService).isMobile || inject(Router).parseUrl('/');

export const routes: Routes = [
    {
        path: 'wiki',
        loadComponent: () => import('./views/wiki/wiki.component').then(m => m.WikiComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('./views/wiki/wiki-gallery/wiki-gallery.component').then(m => m.WikiGalleryComponent),
                pathMatch: 'full'
            },
            {
                path: 'types',
                loadComponent: () => import('./views/wiki/wiki-types/wiki-types.component').then(m => m.WikiTypesComponent),
                pathMatch: 'full'
            },
            {
                path: 'mon/:id',
                loadComponent: () => import('./views/wiki/wiki-mon/wiki-mon.component').then(m => m.WikiMonComponent),
                pathMatch: 'full'
            },
        ]
    },
    {
        path: 'teams',
        loadComponent: () => import('./views/teams/teams.component').then(m => m.TeamsComponent),
        pathMatch: 'full',
        data: { preload: true }
    },
    {
        path: 'leaderboard',
        loadComponent: () => import('./views/leaderboard/leaderboard.component').then(m => m.LeaderboardComponent),
        pathMatch: 'full'
    },
    {
        path: 'stats',
        loadComponent: () => import('./views/stats/stats.component').then(m => m.StatsComponent),
        pathMatch: 'full'
    },
    {
        path: 'profile/:address',
        loadComponent: () => import('./views/profile/profile.component').then(m => m.ProfileComponent),
        pathMatch: 'full'
    },
    {
        path: 'profile',
        loadComponent: () => import('./views/profile/profile.component').then(m => m.ProfileComponent),
        pathMatch: 'full'
    },
    {
        path: 'battle/:battleKey',
        loadComponent: () => import('./views/battle/battle.component').then(m => m.BattleComponent),
        pathMatch: 'full',
        data: { preload: true }
    },
    {
        path: 'battle/:battleKey/replay',
        loadComponent: () => import('./views/battle/battle.component').then(m => m.BattleComponent),
        pathMatch: 'full',
        data: { replay: true }
    },
    {
        path: 'battle/cpu/:battleKey',
        redirectTo: 'battle/:battleKey',
        pathMatch: 'full'
    },
    {
        path: 'settings',
        loadComponent: () => import('./views/settings/settings.component').then(m => m.SettingsComponent),
        // Mobile-only: desktop keeps the header profile dropdown.
        canActivate: [mobileOnly],
        pathMatch: 'full'
    },
    {
        path: 'admin',
        loadComponent: () => import('./views/admin/admin.component').then(m => m.AdminComponent),
        pathMatch: 'full'
    },
    {
        path: 'playground',
        loadComponent: () => import('./views/playground/playground.component').then(m => m.PlaygroundComponent),
        pathMatch: 'full'
    },
    {
        path: 'sim',
        loadComponent: () => import('./views/simulate/simulate.component').then(m => m.SimulateComponent),
        pathMatch: 'full'
    },
    {
        path: 'auth/twitter/callback',
        loadComponent: () => import('./components/twitter-callback/twitter-callback.component').then(m => m.TwitterCallbackComponent),
        pathMatch: 'full'
    },
    {
        path: 'home2',
        loadComponent: () => import('./views/home-deck/home-deck.component').then(m => m.HomeDeckComponent),
        // Mobile-only preview of the card-deck home; desktop falls back to the existing home.
        canActivate: [mobileOnly],
        pathMatch: 'full'
    },
    {
        path: '',
        component: HomeComponent,
        pathMatch: 'full',
        data: { frens: true }

    },
    // Unknown paths land on home rather than a blank router outlet. Must stay last.
    {
        path: '**',
        redirectTo: ''
    }
];